<div class="modal-header py-2 bg-dark text-light">
  <h4 class="modal-title">
    배차정보 일괄등록
  </h4>
</div>

<div class="modal-body">
    <div class="row mt-3">

<!--
        <div class="cal-auto">
            <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="fileinput.value=null;fileinput.click()">
                <i class="fas fa-file-excel"></i>
                <span class="ml-1">운전자추가</span>
                <input #fileinput type="file" (change)="userRegFromExcel($event)" style="display: none" />
            </button>
        </div>
-->

        <div class="col-auto">
            <div class="input-group input-group-sm">

                <div class="input-group-append">
                    <button type="button" class="btn btn-sm btn-outline-success"
                            (click)="fileinput.value=null;fileinput.click()">
                        <input #fileinput type="file" (change)="loadUserCarRunFromExcel($event)" style="display: none" />
                    <!--
                    <button type="button" class="btn btn-outline-secondary"
                          (click)="clickSearch()">
                    -->
                        <i class="fas fa-file-excel"></i>
                        <span class="ml-1">
                            파일
                        </span>
                    </button>
                </div>

                <input type="text" class="form-control" placeholder="파일선택"
                       [(ngModel)]="filePath">

            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
            (click)="clickSave()"
            [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
              등록
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
            (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
              닫기
        </span>
    </button>
</div>
